import * as React from 'react';
const SvgPlay = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M7.417 13.511V6.49q0-.314.204-.494a.694.694 0 0 1 .836-.074l5.399 3.526q.151.103.236.246a.6.6 0 0 1 .086.31.6.6 0 0 1-.086.312.7.7 0 0 1-.236.238l-5.4 3.53a.8.8 0 0 1-.37.103.68.68 0 0 1-.468-.18.63.63 0 0 1-.201-.495'
            />
        </g>
    </svg>
);
export default SvgPlay;
